import { BrowserRouter as Router, Routes, Route, NavLink, Link } from "react-router-dom";
import DataContext from "./context/DataContext";
import React, { useState, useEffect } from "react";
import ImageList, { ImageListRoute } from "./components/ImageList";
import PostPage from "./components/PostPage";
import Footer from "./components/Footer";
import { SunIcon, MoonIcon } from "./components/Icons";
import { initAnalytics } from './services/analytics';
import "./App.css";

// Static for now — Home always shows everything, the rest map to
// `?category=` server-side filtering in ImageList. If categories end up
// coming from the API instead, swap this for state fetched once on mount.
const CATEGORIES = ["AI", "Security", "Gadgets", "Hardware"];

function App() {
  const [items, setItems] = useState([]);
  // Remember the visitor's last theme choice instead of always resetting to light.
  const [darkMode, setDarkMode] = useState(
    () => localStorage.getItem("tekomania-theme") === "dark"
  );

  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    localStorage.setItem("tekomania-theme", darkMode ? "dark" : "light");
  }, [darkMode]);

  return (
    <div className={`App ${darkMode ? "dark-mode" : ""}`} style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Router>
        <header className="banner">
          <Link to="/" className="banner-link">
            <h1>Tekomania</h1>
          </Link>

          <nav className="nav">
            <NavLink to="/" end className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}>
              Home
            </NavLink>
            {CATEGORIES.map((cat) => (
              <NavLink
                key={cat}
                to={`/category/${cat}`}
                className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}
              >
                {cat}
              </NavLink>
            ))}
          </nav>

          <button
            className="dark-toggle"
            onClick={() => setDarkMode(!darkMode)}
            aria-label={darkMode ? "Switch to light mode" : "Switch to dark mode"}
          >
            {darkMode ? <SunIcon /> : <MoonIcon />}
          </button>
        </header>

        <DataContext.Provider value={{ items, setItems }}>
          <main className="main-content">
            <Routes>
              <Route path="/" element={<ImageList />} />
              <Route path="/category/:category" element={<ImageListRoute />} />
              <Route path="/post/:id" element={<PostPage />} />
            </Routes>
          </main>
        </DataContext.Provider>
      </Router>

      {/* Sticky Footer */}
      <Footer />
    </div>
  );
}

export default App;
